import { render, staticRenderFns } from "./AttributesListsEdit.vue?vue&type=template&id=fc4d7c30"
import script from "./AttributesListsEdit.vue?vue&type=script&lang=js"
export * from "./AttributesListsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports